import React, { useState, useEffect } from 'react';
import { MapTypeControls } from './controls/MapTypeControls';
import { ModeControls } from './controls/ModeControls';
import { RecordingControl } from './controls/RecordingControl';
import { LocationControls } from './controls/LocationControls';
import { LayerControls } from './controls/LayerControls';
import { CollapseButton } from './controls/CollapseButton';
import { Divider } from './controls/Divider';
import { ControlsContainer } from './controls/ControlsContainer';

export const MapControls = ({
  className,
  mapType,
  onMapTypeChange,
  mode,
  onModeChange,
  surveyActive,
  showTraffic,
  onToggleTraffic,
  showStreetView,
  onToggleStreetView,
  centerToLocation,
  onToggleCenterLocation,
  showRoutePlanner,
  onToggleRoutePlanner,
  showTeamMembers,
  onToggleTeamMembers,
  isLocked,
  onToggleLock,
  showStatusBar,
  onToggleStatusBar,
  showDirections,
  onToggleDirections,
  defaultCollapsed = false,
}) => {
  const [isCollapsed, setIsCollapsed] = useState(defaultCollapsed);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => setIsCollapsed(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div 
      className={`${className} flex items-center gap-3 transition-transform fixed z-[300] top-[4.5rem] ${
        isCollapsed ? '-translate-x-[calc(100%-24px)]' : 'translate-x-0'
      }`}
    >
      <CollapseButton 
        isCollapsed={isCollapsed} 
        onToggle={() => setIsCollapsed(!isCollapsed)} 
      />

      {!isCollapsed && (
        <ControlsContainer isCollapsed={isCollapsed}>
          <MapTypeControls 
            mapType={mapType} 
            onMapTypeChange={onMapTypeChange} 
          />
          <Divider />

          <ModeControls 
            mode={mode}
            onModeChange={onModeChange}
            surveyActive={surveyActive}
            showRoutePlanner={showRoutePlanner}
            onToggleRoutePlanner={onToggleRoutePlanner}
          />
          <Divider />

          <RecordingControl />
          <Divider />

          <LocationControls 
            centerToLocation={centerToLocation}
            onToggleCenterLocation={onToggleCenterLocation}
            isLocked={isLocked}
            onToggleLock={onToggleLock}
          />
          <Divider />

          <LayerControls 
            showStreetView={showStreetView}
            onToggleStreetView={onToggleStreetView}
            showDirections={showDirections}
            onToggleDirections={onToggleDirections}
            showTeamMembers={showTeamMembers}
            onToggleTeamMembers={onToggleTeamMembers}
            showStatusBar={showStatusBar}
            onToggleStatusBar={onToggleStatusBar}
          />
        </ControlsContainer>
      )}
    </div>
  );
};

export default MapControls;